import {
  AddOutlineMediumIcon,
  createMediaQuery,
  DevicesOutlineMediumIcon,
  MapOutlineMediumIcon,
  PersonInjuryOutlineMediumIcon,
  Section,
  TitleAndDescription,
  UrnOutlineMediumIcon,
} from '@ferreri/prever-component-lib';
import styled from '@emotion/styled';

import { usePlanDetails } from '../plan/helpers';
import PlansFeaturesItem from './PlansFeaturesItem';

export const PlansFeatures = () => {
  const planDetails = usePlanDetails();

  const featureItems = [
    {
      title: 'Cobertura nacional',
      icon: <MapOutlineMediumIcon />,
      body: `${planDetails?.coverage}.`,
    },
    {
      title: 'Cuidados para saúde',
      icon: <PersonInjuryOutlineMediumIcon />,
      body: 'Rede de clínicas, laboratórios e descontos em medicamentos.',
    },
    {
      title: 'Teleconsultas',
      icon: <DevicesOutlineMediumIcon />,
      body: 'Teleconsultas médicas com atendimento rápido e seguro.',
    },
    {
      title: 'Pós-óbito',
      icon: <UrnOutlineMediumIcon />,
      body: 'Assistência psicológica e jurídica.',
    },
    {
      title: 'E muito mais...',
      icon: <AddOutlineMediumIcon />,
      body: 'Muitos benefícios para todo ciclo de vida.',
    },
  ];

  return (
    <Section>
      <TitleAndDescription
        title="Um plano completo"
        description="Completo para você e sua família! Conte com:"
      />
      <GroupfeatureItems>
        {featureItems.map((item, index) => (
          <PlansFeaturesItem
            key={index}
            icon={item.icon}
            title={item.title}
            body={item.body}
          />
        ))}
      </GroupfeatureItems>
    </Section>
  );
};

const GroupfeatureItems = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  ${createMediaQuery({
    desktop: {
      gridTemplateColumns: 'repeat(5, 1fr)',
    },
  })};
`;
